import { forwardRef } from 'react';
import {
  StyledHolder,
  StyledBanner,
  StyledShadow,
  StyledWrapper,
} from './styled';

const Banner = forwardRef((props, ref) => {
  const { src, alt, ...rest } = props;

  if (src) {
    return (
      <StyledWrapper>
        <StyledBanner ref={ref} src={src} alt={alt} {...rest} />
        <StyledShadow />
      </StyledWrapper>
    );
  } else {
    return (
      <StyledWrapper>
        <StyledHolder ref={ref} {...rest} />
        <StyledShadow />
      </StyledWrapper>
    );
  }
});

export default Banner;
